import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  useEditLeadPoolMutation,
  useGetAgentsQuery,
  useGetLeadsPoolQuery,
} from "../../redux/api/leadsApi";
import styled from "styled-components";
import { LeadTable } from "./LeadTable";
import { LEADS_POOL_COLUMNS } from "./leadsData";
import { selectCurrentAgent } from "../../redux/features/authSlice";
import { isDisabled } from "../../helper/agentRights";

export default function LeadPool() {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const currentAgent = useSelector(selectCurrentAgent);
  const [selectedLeads, setSelectedLeads] = useState([]); // Store selected leads
  const {
    data: agencyLeadsPool,
    isLoading: LeadsLoading,
    refetch,
  } = useGetLeadsPoolQuery({ agencyId: currentAgent?.agencyid });
  const { data: allAgents } = useGetAgentsQuery(currentAgent?.agencyid);
  const [editLeadPool] = useEditLeadPoolMutation();

  const onChangeAction = (e, leads) => {
    if (e.target.value === 0) {
      // Open agent selection dialog
      setDialogOpen(true);
      setSelectedLeads(leads); // Store selected leads when opening the dialog
    }
  };
  // const handleAssign = () => {
  //   if (selectedAgentId) {
  //     const formattedLeads = selectedLeads.map((lead) => {
  //       // const leadId = lead.Properties[0]?.leadid;
  //       return {
  //         leadSerialNo: lead.leadSerialNo,
  //         leadid: lead.leadid,
  //         userid: lead.userid,
  //         propertyid: lead.propertyid,
  //         description: lead.description,
  //         leadtype: lead.leadtype,
  //         leadTime: lead.leadTime,
  //         agentid: selectedAgentId,
  //         agencyid: currentAgent?.agencyid,
  //         leadTag: lead.leadTag,
  //         leadStatus: lead.leadStatus,
  //         sourceId: lead.sourceId,
  //         mediumId: lead.mediumId,
  //         priorityId: lead.priorityId,
  //         companyName: lead.companyName,
  //         designation: lead.designation,
  //         budget: lead.budget,
  //         location: lead.location,
  //         societyName: lead.societyName,
  //         fileNo: lead.fileNo,
  //         block: lead.block,
  //         plotNo: lead.plotNo,
  //         plotSize: lead.plotSize,
  //         type: lead.type,
  //         whatsappNo: lead.whatsappNo,
  //         additionalNo: lead.additionalNo,
  //         membershipId: lead.membershipId,
  //       };
  //     });
  //     editLeadPool(formattedLeads)
  //       .unwrap()
  //       .then((response) => {
  //         refetch()
  //         setDialogOpen(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error updating leads", error);
  //       });
  //   }
  // };
  const handleAssign = () => {
    if (selectedAgentId) {
      const leadIds = selectedLeads.map((lead) => lead.leadid);

      const payload = {
        leadIds,
        agentId: selectedAgentId,
      };

      editLeadPool(payload)
        .unwrap()
        .then((response) => {
          refetch();
          setDialogOpen(false);
        })
        .catch((error) => {
          console.error("Error updating leads", error);
        });
    }
  };

  // Hide columns
  const leadsPermissions = currentAgent.leadsrights[0];

  const normalizeKey = (key) =>
    key
      ?.toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "");

  const filteredColumns = LEADS_POOL_COLUMNS.filter((col) => {
    const key = normalizeKey(col.accessorKey);
    if (!key) return true; // Keep fixed columns without permission flags
    const matchedPermission = Object.keys(leadsPermissions).find(
      (permKey) => normalizeKey(permKey) === key
    );
    return matchedPermission
      ? leadsPermissions[matchedPermission] !== false
      : true;
  });

  const agentRights = currentAgent.agentrights || {};
  const canAssignLeads = !isDisabled(agentRights, "Assign Lead");

  return (
    <div>
      <StyledTop>
        <StyledButton size="small" variant="contained" sx={{ color: "white" }}>
          All Pool Leads
        </StyledButton>
      </StyledTop>

      <LeadTable
        key={2}
        columns={filteredColumns}
        leads={agencyLeadsPool || []}
        isLoading={LeadsLoading}
        allAgents={allAgents}
        onChangeAction={onChangeAction}
      />

      <Dialog
        open={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Select Agent</DialogTitle>
        <DialogContent>
          <RadioGroup
            value={selectedAgentId}
            onChange={(e) => setSelectedAgentId(e.target.value)}
          >
            {allAgents &&
              allAgents.map((agent) => (
                <FormControlLabel
                  key={agent.agentid}
                  value={agent.agentid?.toString()}
                  control={<Radio />}
                  label={agent.agentname}
                />
              ))}
          </RadioGroup>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>

          {canAssignLeads ? (
            <Button onClick={handleAssign} disabled={!selectedAgentId}>
              Assign
            </Button>
          ) : (
            <Tooltip title="You don't have permission to assign leads">
              <span>
                <Button disabled style={{ pointerEvents: "none" }}>
                  Assign
                </Button>
              </span>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  marginRight: "8px",
}));

const StyledTop = styled("div")(({ theme }) => ({
  marginTop: "16px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  rowGap: "20px",
}));
